import api from '../api'

//default state
export const DEFAULT_STATE = {
    currentUser: null,
    isLoading: false,
    error: null,
};

//types
export const LOGIN = 'LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const VERIFY_TOKEN = 'VERIFY_TOKEN';
export const LOGOUT = 'LOGOUT';


//selectors
export const getIsLoginLoading = (state) => state && state.login && state.login.isLoading;
export const getCurrentUser = (state) => state && state.login && state.login.currentUser;
export const getError = (state) => state && state.login && state.login.error;

//actions
export const logout = () => (dispatch, state) => {
    localStorage.removeItem('token');
    dispatch({
        type: LOGOUT
    })
}

export const fetchVerifyToken = () => (dispatch, state) => {
    api.verifyToken()
        .then((res) => {
            dispatch({
                type: LOGIN_SUCCESS,
                payload: res.data.user
            })
        })
        .catch(err => {
            dispatch({
                type: LOGIN_FAILURE,
                payload: err.response.data.error
            })
            window.location.href = window.location.origin + '/login'
        })
}

export const fetchLogin = (userInfo) => (dispatch, state) => {
    dispatch({
        type: LOGIN
    })
    api.login(userInfo)
        .then((res) => {
            localStorage.setItem('token', res.data.token);
            dispatch({
                type: LOGIN_SUCCESS,
                payload: res.data.user
            });
        })
        .catch(err => dispatch({
            type: LOGIN_FAILURE,
            payload: err.response.data.error
        }))
}


//reducer
// eslint-disable-next-line
export default function (state = DEFAULT_STATE, action) {
    const { type, payload } = action;

    switch (type) {
        case LOGIN:
            return { ...state, isLoading: true, error: null }
        case LOGIN_SUCCESS:
            return { ...state, isLoading: false, error: null, currentUser: payload }
        case LOGIN_FAILURE:
            localStorage.removeItem('token');
            return { ...state, isLoading: false, error: payload, currentUser: null }
        case LOGOUT:
            return { ...state, currentUser: null }
        default:
            return state;
    }
}